module.exports = __webpack_public_path__ + "media/images/flags/1x1/zaf-2c7ea48c015051bf48a65b4df4667607.svg";